import { render, staticRenderFns } from "./ModeOfContact.vue?vue&type=template&id=1f5ecf19&scoped=true&"
import script from "./ModeOfContact.vue?vue&type=script&lang=js&"
export * from "./ModeOfContact.vue?vue&type=script&lang=js&"
import style0 from "./ModeOfContact.vue?vue&type=style&index=0&id=1f5ecf19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5ecf19",
  null
  
)

export default component.exports